import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CheckboxGroup, Typography } from '@telus-uds/components-web';

import { BoldFieldLabel, FieldWrapper } from './css';
import Note from '../../note';

const FieldMultiCheckbox = ({ data }) => {
  const {
    name,
    label,
    options,
    required,
    onChange,
    note,
    readonly,
    formFields,
    value: fieldValue,
    isShowNoteBackground
  } = data;
  
  // Convert fieldValue to array of checked IDs
  const updateFieldValue =
    typeof fieldValue === 'string' ? fieldValue.split(',') : (fieldValue || []);
  
  // Create items array for CheckboxGroup
  const items = Array.isArray(options) ? options.map(op => {
    const itemLabel = op.fields?.label || '';
    const LabelLogic =
      formFields && formFields.telusOptikTvComments
        ? itemLabel.split('($')[0]
        : itemLabel;

    return {
      label: LabelLogic || '',
      id: op.fields?.value || '',
      ...((readonly || op.fields?.disabledOption) && { inactive: true })
    };
  }) : [];

  // Get checked IDs from fieldValue
  const [checkedIds, setCheckedIds] = useState(updateFieldValue);

  useEffect(() => {
    const newCheckedIds = typeof fieldValue === 'string' 
      ? fieldValue.split(',').filter(Boolean)
      : (fieldValue || []);
    setCheckedIds(newCheckedIds);
  }, [fieldValue]);

  const handleChange = (checkedIdsArray) => {
    setCheckedIds(checkedIdsArray);
    // Call the original onChange handler with event-like object for compatibility
    const event = {
      target: { 
        name: name, 
        value: checkedIdsArray 
      }
    };
    return onChange && onChange(event);
  };

  return (
    <FieldWrapper>
      {note && note.content && (
        <Note
          type="richText"
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
      {items && items.length > 0 ? (
        <>
          <BoldFieldLabel>
            <Typography block heading="h4" variant={{ size: 'h4', bold: true }}>
              {label}
              {required && `*`}
            </Typography>
          </BoldFieldLabel>
          <CheckboxGroup
            tokens={{ space: 0, fieldSpace: 0 }}
            legend={null}
            items={items}
            checkedIds={checkedIds}
            onChange={handleChange}
            name={name}
            inactive={readonly}
          />
        </>
      ) : (
        <Typography block>Not available</Typography>
      )}
    </FieldWrapper>
  );
};

FieldMultiCheckbox.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    readonly: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string
      })
    ).isRequired
  }).isRequired
};

export default FieldMultiCheckbox;
